/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getHygraphCosmosPageData, ContentTypeNames } from "@cosmos/hygraph-data";
import { EntityTypeName, Locale } from "@cosmos/hygraph-schema";

import type { HeroTypeNames, PageHeroTypeNames } from "./page.types";
import type {
	CosmosEntityFragment,
	CosmosPageHeroQuery,
	EntityWhereInput,
	PageHeroesFragment,
} from "@cosmos/hygraph-schema";

export const getHeroContentType = (typenameStr: string): PageHeroTypeNames => {
	let contentType: ContentTypeNames = "CosmosPageHeroAlpha";
	switch (typenameStr) {
		case "CosmosHeroAlpha":
			contentType = "CosmosPageHeroAlpha";
			break;
		case "CosmosHeroGlow":
			contentType = "CosmosPageHeroGlow";
			break;
		case "CosmosHeroArticleImage":
			contentType = "CosmosPageHeroArticleImage";
			break;
		case "CosmosHeroBravo":
			contentType = "CosmosPageHeroBravo";
			break;
	}

	return contentType;
};

export const getHeroEntityQuery = async (
	heroEntity: EntityWhereInput | null | undefined,
	typenameStr: string,
	locale: string,
	preview?: string,
): Promise<PageHeroesFragment | null> => {
	if (heroEntity) {
		try {
			const promise = (
				getHygraphCosmosPageData(
					getHeroContentType(typenameStr),
					{
						entities: [heroEntity],
						locale: [locale, Locale.En] as Locale[],
					},
					preview,
				) as Promise<CosmosPageHeroQuery>
			)
				.then((data) => (data?.entities?.length && data.entities[0] ? (data.entities[0] as PageHeroesFragment) : null))
				.catch((e) => {
					console.error("Hero load error", { heroEntity, error: e });
					return null;
				});
			return promise;
		} catch (e) {
			console.error("Hero load error", { heroEntity, error: e });
		}
	}

	return null;
};

/**
 * Fetch the entity for the hero
 */
export const getHeroDetails = async (
	hero: CosmosEntityFragment | undefined | null,
	locale: string,
	preview?: string,
): Promise<PageHeroesFragment | null> => {
	if (hero) {
		const typenameStr = hero?.__typename as HeroTypeNames;
		const heroEntity: EntityWhereInput | null | undefined = {
			id: hero.id,
			stage: hero.stage,
			typename: EntityTypeName[typenameStr],
		};
		return getHeroEntityQuery(heroEntity, typenameStr, locale, preview);
	}
	return null;
};
